//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable'
import { mapMutations, mapGetters } from 'vuex'
import { floatingWindowFun } from './../../utils/floatingWindow';
import storage from 'storejs';
import storageByCode from "../../utils/storageByCode";

export default {
  computed: {
    ...mapGetters(['isWeChat'])
  },
  data() {
    return {
      bigIconTop: 0
    }
  },
  created() {
    storage.remove('YXGJ-SMALL-X');
    storage.remove('YXGJ-SMALL-Y');
  },
  mounted() {
    this.hideLoad()
    let self = this
    self.$nextTick(() => {
      console.log(self.$refs.smallIcon)
      floatingWindowFun(self.$refs.smallIcon)
    })
  },
  computed: {
    ...mapGetters(['feedbackStatus', 'system', 'isApp', 'isWeChat'])
  },
  methods: {
    ...mapMutations([
      'showLoad',
      'hideLoad',
      "feedbackStatusCommit"
    ]),
    changeStatus() {
      let self = this;
      this.feedbackStatusCommit(!this.feedbackStatus)
      if (this.feedbackStatus) {
        self.$nextTick(() => {
          // if (this.feedbackStatus) { // 显示大图标
          let X = storageByCode('YXGJ-SMALL-X') ? storageByCode('YXGJ-SMALL-X') : 0;
          let Y = storageByCode('YXGJ-SMALL-Y') ? storageByCode('YXGJ-SMALL-Y') : 0;
          console.log(X, Y)

          let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
          console.log(windowHeight)
          let bigIconHeight = this.$refs.bigIcon.offsetHeight
          let bigIconRound = windowHeight * 0.8 + Y
          console.log(bigIconRound)
          if ((bigIconRound + bigIconHeight * 2) >= (windowHeight - 100)) {
            self.bigIconTop = windowHeight * 0.8 + Y - bigIconHeight
          } else {
            self.bigIconTop = windowHeight * 0.8 + Y + bigIconHeight
          }
          console.log(self.bigIconTop)
          console.log('this.$refs.bigIcon.offsetHeight=' + this.$refs.bigIcon.offsetHeight)
        })
      }
    },
    toFeedback() {
      let self = this
      if (self.feedbackStatus) {
        if (self.isApp && !isWeChat) { // 跳转到APP的 意见反馈
          FeedBackActivity()
        } else { // 跳转到 吐个槽
          let productId = 95661; // 为腾讯问卷公众号的产品 id
          /* 请注意url单词是product而不是products，products是旧版本的参数，用错地址将不能成功提交 */
          window.location.href = 'https://support.qq.com/product/' + productId
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/feedback.vue